export const PLANO_CONTA_TIPO_CONTA_ENUM = [
    {
        id: 'S',
        descricao: "Sintética - Conta de Agrupamento"
    },
    {
        id: 'A',
        descricao: "Analítica - Conta de Movimentação"
    }
];